export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Criando widget para"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cancelar"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Conta"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Gerar"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pagamento em"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Quantia do pagamento"])},
  "7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ações em caso de sucesso"])},
  "8": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ações em caso de falha"])}
}